import wx from 'weixin-js-sdk'

/** 与 utils/index.js 中 isWeChatMiniApp 行为一致（本文件不引用 index，避免循环依赖） */
function isWeChatMiniAppEnv() {
  const ua = window.navigator.userAgent.toLowerCase()
  return new Promise(resolve => {
    if (ua.indexOf('micromessenger') === -1) {
      resolve(false)
    } else {
      wx.miniProgram.getEnv(res => {
        resolve(!!res.miniprogram)
      })
    }
  })
}

function stripPassportFromLink(link) {
  if (!link || typeof link !== 'string' || link.indexOf('passport') === -1) return link
  return link
    .replace(/&passport=[^&#]*/gi, '')
    .replace(/\?passport=[^&#]*&/gi, '?')
    .replace(/\?passport=[^&#]*/gi, '')
}

/**
 * 用当前路由拼出完整 H5 地址。部分 webview 下 location.href 不含 # 后路径，
 * 分享会一直是进入 webview 时的首页，需用 hash 路由的 fullPath。
 * 拼好后会去掉 URL 中的 passport 参数（含 hash 内 query），避免分享带登录态。
 * @param {import('vue-router').Route} [route] - 传入 this.$route
 * @returns {string}
 */
export function buildWebviewShareFullUrl(route) {
  if (typeof window === 'undefined' || !window.location) return ''
  const href = window.location.href || ''
  const base = href.split('#')[0] || href
  let out
  if (route && route.fullPath) {
    out = base + '#' + route.fullPath
  } else {
    out = href
  }
  return stripPassportFromLink(out)
}

/**
 * 微信小程序 web-view：与全局 wxShare 分流不同，需在小程序环境单独 postMessage，
 * 供宿主页 bindmessage 使用，避免分享仍指向首次进入 webview 时的 URL。
 * @param {{ title: string, abstract: string, image: string, link: string }} shareObj
 * @param {import('vue-router').Route} [route] - 建议传入 this.$route，用于修正 hash 与当前页一致
 */
export function notifyMiniProgramShare(shareObj, route) {
  if (!shareObj || typeof shareObj !== 'object') return
  let link = buildWebviewShareFullUrl(route) || shareObj.link
  if (!link) return
  link = stripPassportFromLink(link)
  isWeChatMiniAppEnv().then(isMini => {
    if (!isMini || !wx.miniProgram || typeof wx.miniProgram.postMessage !== 'function') return
    wx.miniProgram.postMessage({
      data: {
        type: 'setShareData',
        shareData: {
          title: shareObj.title,
          desc: shareObj.abstract,
          imageUrl: shareObj.image,
          path: '/pages/webview/index?redirect=' + encodeURIComponent(link)
        }
      }
    })
  })
}
